module.exports = __webpack_public_path__ + "img/control-arm.d3ef50b0.jpg";